// Which milestone invoices go through Coupa.
//
// Only clients paying through Coupa issue POs numbered 6000-..., for example
// 6000-01030538, so a PO starting 6000 is what marks an invoice Finance must
// see approved on Coupa (Matt Smith, 2 November 2026). The PO is the
// milestone's own customer PO where one was recorded, otherwise the SOW's: the
// same rule as the Milestones Reporting tab (milestonePo in milestoneReport.js).
//
// Shared by the Coupa approved column and the chase sweep
// (src/lib/coupaChaseActions.js), which applies the same test in SQL.

export const COUPA_PO_PREFIX = '6000';

/** The PO a milestone is billed against, trimmed. */
export const milestoneBillingPo = (m) =>
  String((String(m?.customer_po ?? '').trim()) || m?.sow_po_number || '').trim();

/** Is this PO number a Coupa one? */
export const isCoupaPo = (po) => String(po ?? '').trim().startsWith(COUPA_PO_PREFIX);

/** Is this milestone billed on a Coupa PO? */
export const isCoupaMilestone = (m) => isCoupaPo(milestoneBillingPo(m));
